import React from 'react';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { Button } from 'antd';

export function exportXls(data, role) {
  import('exceljs').then(({ default: ExcelJS }) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');

    if (role === 'student') {
      worksheet.getColumn(1).width = 7;
      worksheet.getColumn(1).alignment = { wrapText: true, vertical: 'middle', horizontal: 'left' };
      worksheet.getColumn(1).font = {
        bold: true,
      };
      worksheet.getColumn(2).width = 35;
      worksheet.getColumn(2).alignment = { vertical: 'middle', horizontal: 'left' };
      worksheet.getColumn(3).width = 45;
      worksheet.getColumn(3).alignment = { vertical: 'middle', horizontal: 'left' };
      worksheet.getColumn(4).width = 30;
      worksheet.getColumn(4).alignment = { vertical: 'middle', horizontal: 'left' };
      worksheet.getColumn(5).width = 15;
      worksheet.getColumn(5).alignment = { wrapText: true, vertical: 'middle', horizontal: 'left' };

      worksheet.getRow(1).font = {
        bold: true,
      };
      worksheet.getRow(5).font = {
        bold: true,
      };

      let row = worksheet.getRow(1);
      row.getCell(2).value = 'Экзамен';
      row.getCell(3).value = 'Дата проведения';
      row.getCell(4).value = 'Предмет';
      row.getCell(5).value = 'Итоговый балл';

      worksheet.getRow(2).getCell(2).value = data.data.column1.examname;
      worksheet.getRow(2).getCell(3).value = data.data.column1.examDate;
      worksheet.getRow(2).getCell(4).value = data.data.column1.subject;
      worksheet.getRow(2).getCell(5).value = data.data.column1.totalPoint;

      let row2 = worksheet.getRow(5);
      row2.getCell(2).value = 'Преподаватель';
      row2.getCell(3).value = 'Группа';
      row2.getCell(4).value = 'Тема';
      row2.getCell(5).value = '№ варианта';

      worksheet.getRow(6).getCell(2).value = data.data.column2.teacher;
      worksheet.getRow(6).getCell(3).value = data.data.column2.group;
      worksheet.getRow(6).getCell(4).value = data.data.column2.topic;
      worksheet.getRow(6).getCell(5).value = data.data.column2.variantNumber;
      for (let i = 0; i < data.data.column2.questions.length; i++) {
        worksheet.getRow(5).getCell(6 + i).value = `Вопрос ${i + 1}`;
        worksheet.getRow(6).getCell(6 + i).value = data.data.column2.questions[i];

        if (data.data.column2.questions.length - 1 === i) {
          worksheet.getRow(5).getCell(7 + i).value = `Итоговый балл`;
          worksheet.getRow(6).getCell(7 + i).value = data.data.column2.totalPoint;
        }
      }
    }
    if (role === 'teacher') {
      worksheet.getColumn(1).width = 7;
      worksheet.getColumn(1).alignment = {
        wrapText: true,
        vertical: 'middle',
        horizontal: 'left',
      };
      worksheet.getColumn(1).font = {
        bold: true,
      };
      worksheet.getColumn(2).width = 35;
      worksheet.getColumn(2).alignment = { vertical: 'middle', horizontal: 'left' };
      worksheet.getColumn(3).width = 45;
      worksheet.getColumn(3).alignment = { vertical: 'middle', horizontal: 'left' };
      worksheet.getColumn(4).width = 30;
      worksheet.getColumn(4).alignment = { vertical: 'middle', horizontal: 'left' };
      worksheet.getColumn(5).width = 35;
      worksheet.getColumn(5).alignment = {
        wrapText: true,
        vertical: 'middle',
        horizontal: 'left',
      };
      worksheet.getColumn(6).width = 35;
      worksheet.getColumn(6).alignment = { vertical: 'middle', horizontal: 'left' };
      worksheet.getColumn(7).width = 35;
      worksheet.getColumn(7).alignment = { vertical: 'middle', horizontal: 'left' };
      worksheet.getColumn(8).width = 35;
      worksheet.getColumn(8).alignment = { vertical: 'middle', horizontal: 'left' };

      worksheet.getRow(1).font = {
        bold: true,
      };
      worksheet.getRow(5).font = {
        bold: true,
      };

      let row = worksheet.getRow(1);
      row.getCell(2).value = 'Экзамен';
      row.getCell(3).value = 'Тема';
      row.getCell(4).value = 'Дата проведения';
      row.getCell(5).value = 'Средний балл(А)';
      row.getCell(6).value = 'Средний балл(В)';
      row.getCell(7).value = 'Средний балл(С)';
      row.getCell(8).value = 'Средний балл(общий)';

      worksheet.getRow(2).getCell(2).value = data.data.column1.examname;
      worksheet.getRow(2).getCell(3).value = data.data.column2.topic;
      worksheet.getRow(2).getCell(4).value = data.data.column1.examDate;
      worksheet.getRow(2).getCell(5).value = data.data.column1.avgA;
      worksheet.getRow(2).getCell(6).value = data.data.column1.avgB;
      worksheet.getRow(2).getCell(7).value = data.data.column1.avgC;
      worksheet.getRow(2).getCell(8).value = data.data.column1.avgTotal;

      let row2 = worksheet.getRow(5);
      row2.getCell(2).value = 'Ученик';
      row2.getCell(3).value = 'Группа';
      row2.getCell(4).value = 'Тема';
      row2.getCell(5).value = '№ варианта';

      worksheet.getRow(6).getCell(3).value = data.data.column2.group;
      worksheet.getRow(6).getCell(4).value = data.data.column2.topic;
      // worksheet.getRow(6).getCell(5).value = data.data.column2.variantNumber;
      for (let i = 0; i < data.data.column2.students.length; i++) {
        worksheet
          .getRow(6 + i)
          .getCell(
            2,
          ).value = `${data.data.column2.students[i].exam.studentsList[i].lastName} ${data.data.column2.students[i].exam.studentsList[i].firstName} ${data.data.column2.students[i].exam.studentsList[i].middleName}`;

        worksheet.getRow(6 + i).getCell(5).value = data.data.column2.students[i].variantNumber;
        worksheet.getRow(6 + i).getCell(3).value = data.data.column2.group;
        worksheet.getRow(6 + i).getCell(4).value = data.data.column2.topic;
      }

      for (let i = 0; i < data.data.column2.students[0].questionIds.length; i++) {
        worksheet.getRow(5).getCell(6 + i).value = `Вопрос ${i + 1}`;
        worksheet.getColumn(6 + i).width = 25;
      }

      for (let i = 0; i < data.data.column2.students.length; i++) {
        for (let j = 0; j < data.data.column2.students[0].questionIds.length; j++) {
          if (data.data.column2.students[i].studentAnswers[j]?.point === null) {
            worksheet
              .getRow(6 + i)
              .getCell(
                6 + j,
              ).value = `0 / ${data.data.column2.students[i].exam.questionsPoints[j]?.point}`;

            if (data.data.column2.students[0].questionIds.length - 1 === j) {
              worksheet.getRow(5).getCell(7 + j).value = `Итоговый балл`;
              worksheet.getRow(6 + i).getCell(7 + j).value =
                data.data.column2.students[i].totalPoint !== null &&
                data.data.column2.students[i].maxTotalPoint !== null
                  ? `${data.data.column2.students[i].totalPoint} / ${data.data.column2.students[i].maxTotalPoint}`
                  : 'Не сдал экзамен';
            }
          }

          if (data.data.column2.students[i].studentAnswers[j]?.point === undefined) {
            worksheet.getRow(6 + i).getCell(6 + j).value = '';

            if (data.data.column2.students[0].questionIds.length - 1 === j) {
              worksheet.getRow(5).getCell(7 + j).value = `Итоговый балл`;
              worksheet.getRow(6 + i).getCell(7 + j).value =
                data.data.column2.students[i].totalPoint !== null &&
                data.data.column2.students[i].maxTotalPoint !== null
                  ? `${data.data.column2.students[i].totalPoint} / ${data.data.column2.students[i].maxTotalPoint}`
                  : 'Не сдал экзамен';
            }
          }

          if (
            data.data.column2.students[i].studentAnswers[j]?.point !== null &&
            data.data.column2.students[i].studentAnswers[j]?.point !== undefined
          ) {
            worksheet
              .getRow(6 + i)
              .getCell(
                6 + j,
              ).value = `${data.data.column2.students[i].studentAnswers[j]?.point} / ${data.data.column2.students[i].exam.questionsPoints[j]?.point}`;

            if (data.data.column2.students[0].questionIds.length - 1 === j) {
              worksheet.getRow(5).getCell(7 + j).value = `Итоговый балл`;
              worksheet.getRow(6 + i).getCell(7 + j).value =
                data.data.column2.students[i].totalPoint !== null &&
                data.data.column2.students[i].maxTotalPoint !== null
                  ? `${data.data.column2.students[i].totalPoint} / ${data.data.column2.students[i].maxTotalPoint}`
                  : 'Не сдал экзамен';
            }
          }
        }
      }
    }

    workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(
        new Blob([buffer], {
          type: 'application/octet-stream',
        }),
        `Отчет по экзамену.xlsx`,
      );
    });
  });
}

function Report() {
  const data = '';
  return (
    <>
      <h1>Страница Отчетов</h1>
      <Button onClick={() => exportXls(data)}>Скачать отчет</Button>
    </>
  );
}

export default Report;
